import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const replacements = [
    {
        current: 'WhatsApp for scheduling',
        medzhub: 'Admin portal dispatch',
    },
    {
        current: 'Phone calls for verification',
        medzhub: 'Verified check-in and session confirmation',
    },
    {
        current: 'Excel for payouts',
        medzhub: 'Verified session-linked payout queue',
    },
    {
        current: 'Paper or personal phones for documentation',
        medzhub: 'Structured on-site session notes',
    },
];

const WhatChangesSection = () => {
    return (
        <Box
            component="section"
            aria-labelledby="what-changes-heading"
            sx={{
                pt: { xs: 7, md: 7.5, lg: 8 },
                pb: { xs: 4, md: 4.5, lg: 4.5 },
                background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFBFF 100%)',
                borderBottom: '1px solid rgba(0, 102, 255, 0.06)',
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', maxWidth: 920, mx: 'auto', mb: { xs: 3.5, md: 5 } }}>
                    <Typography
                        component="span"
                        sx={{
                            display: 'inline-block',
                            fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                            fontWeight: 700,
                            letterSpacing: '0.18em',
                            textTransform: 'uppercase',
                            color: '#0066FF',
                            bgcolor: 'rgba(0, 102, 255, 0.1)',
                            px: { xs: 1.75, sm: 2.25 },
                            py: 0.75,
                            borderRadius: 999,
                            mb: 2.5,
                        }}
                    >
                        WHAT CHANGES
                    </Typography>

                    <Typography
                        id="what-changes-heading"
                        variant="h2"
                        sx={{
                            fontSize: { xs: '1.75rem', sm: '2.125rem', md: '2.5rem' },
                            fontWeight: 700,
                            lineHeight: 1.2,
                            letterSpacing: '-0.03em',
                            color: '#0F172A',
                            mb: 2.5,
                        }}
                    >
                        What meDZhub replaces
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                            lineHeight: 1.75,
                            color: 'rgba(15, 23, 42, 0.78)',
                            textAlign: 'center',
                        }}
                    >
                        Most providers are currently stitching together WhatsApp for scheduling, phone calls for verification,
                        Excel for payouts, and paper or personal phones for documentation.
                    </Typography>
                </Box>

                <Box
                    sx={{
                        borderRadius: 3,
                        overflow: 'hidden',
                        border: '1px solid rgba(0, 102, 255, 0.12)',
                        boxShadow: '0 14px 40px rgba(15, 23, 42, 0.06)',
                        mb: { xs: 3, md: 4 },
                    }}
                >
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                            background: 'linear-gradient(90deg, rgba(248, 250, 252, 0.95) 0%, rgba(241, 245, 255, 0.95) 100%)',
                            borderBottom: '1px solid rgba(0, 102, 255, 0.12)',
                        }}
                    >
                        <Typography
                            sx={{
                                px: { xs: 2.5, md: 3 },
                                py: { xs: 1.6, md: 1.9 },
                                fontSize: { xs: '0.9rem', md: '0.95rem' },
                                fontWeight: 700,
                                color: '#0F172A',
                                textAlign: 'center',
                                borderRight: { xs: 'none', md: '1px solid rgba(0, 102, 255, 0.12)' },
                                borderBottom: { xs: '1px solid rgba(0, 102, 255, 0.12)', md: 'none' },
                            }}
                        >
                            Currently
                        </Typography>
                        <Typography
                            sx={{
                                px: { xs: 2.5, md: 3 },
                                py: { xs: 1.6, md: 1.9 },
                                fontSize: { xs: '0.9rem', md: '0.95rem' },
                                fontWeight: 700,
                                color: '#0F172A',
                                textAlign: 'center',
                            }}
                        >
                            With meDZhub
                        </Typography>
                    </Box>

                    {replacements.map((item, index) => (
                        <Box
                            key={item.current}
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                                borderBottom: index === replacements.length - 1 ? 'none' : '1px solid rgba(0, 102, 255, 0.1)',
                                backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#FBFDFF',
                            }}
                        >
                            <Typography
                                sx={{
                                    px: { xs: 2.5, md: 3 },
                                    py: { xs: 1.8, md: 2 },
                                    fontSize: { xs: '0.94rem', md: '1rem' },
                                    lineHeight: 1.6,
                                    color: 'rgba(15, 23, 42, 0.8)',
                                    textAlign: 'center',
                                    borderRight: { xs: 'none', md: '1px solid rgba(0, 102, 255, 0.1)' },
                                    borderBottom: { xs: '1px solid rgba(0, 102, 255, 0.1)', md: 'none' },
                                }}
                            >
                                {item.current}
                            </Typography>
                            <Typography
                                sx={{
                                    px: { xs: 2.5, md: 3 },
                                    py: { xs: 1.8, md: 2 },
                                    fontSize: { xs: '0.94rem', md: '1rem' },
                                    lineHeight: 1.6,
                                    color: '#0F172A',
                                    textAlign: 'center',
                                    fontWeight: 600,
                                }}
                            >
                                {item.medzhub}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                <Typography
                    sx={{
                        textAlign: 'center',
                        fontSize: { xs: '1.02rem', md: '1.12rem' },
                        lineHeight: 1.7,
                        color: '#0F172A',
                        fontWeight: 500,
                        maxWidth: 760,
                        mx: 'auto',
                    }}
                >
                    meDZhub doesn't integrate with those. It replaces them.
                </Typography>
            </Container>
        </Box>
    );
};

export default WhatChangesSection;
